export enum EntityTypeDefaultImageEnum {
    OUTLET  = 'assets/images/placeholder-outlet-big.svg',
    CONTACT = 'assets/images/placeholder-user-big.svg',
    SMALL_OUTLET = 'assets/images/placeholder-outlet-small.svg',
    SMALL_CONTACT = 'assets/images/placeholder-user-small.svg'
};
